import { PluginEvent } from '../../enums/plugin_event';
export const REQUEST_TRANSFORMER_PLUGIN_NAME = 'request-transformer';
class RequestTransformer {
    constructor(options) {
        this.name = REQUEST_TRANSFORMER_PLUGIN_NAME;
        this._uriTransformer = options.uriTransformer;
        this._optionsOverrides = options.optionsOverrides;
        this._include = options.include;
        // Rebind
        this._processRequest = this._processRequest.bind(this);
    }
    _processRequest(ev) {
        var _a, _b;
        const requestData = ev.data;
        if (((_b = (_a = requestData.options) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.noRequestTransform) ||
            (this._include && !this._include(requestData.uri, requestData.options))) {
            return;
        }
        // If there is a URI Transformer, we pass the original URI to get the
        // new Transformed URI.
        if (this._uriTransformer) {
            requestData.uri = this._uriTransformer(requestData.uri);
        }
        const optionsOverrides = this._optionsOverrides;
        if (optionsOverrides) {
            if (!requestData.options) {
                // If there are no request options, we just used the defaults defined
                // here.
                requestData.options = optionsOverrides;
            }
            else {
                // We need to merge the two options.
                const mergedOptions = Object.assign(Object.assign(Object.assign({}, requestData.options), optionsOverrides), { 
                    // Then merge any object options
                    metadata: Object.assign(Object.assign({}, requestData.options.metadata), optionsOverrides.metadata), retry: Object.assign(Object.assign({}, requestData.options.retry), optionsOverrides.retry), headers: Object.assign(Object.assign({}, requestData.options.headers), optionsOverrides.headers) });
                requestData.options = mergedOptions;
            }
        }
    }
    attach(_t, m) {
        m.on(PluginEvent.TRANSPORT_BEFORE_PROCESS_REQUEST, this._processRequest);
    }
    detach(_t, m) {
        m.removeListener(PluginEvent.TRANSPORT_BEFORE_PROCESS_REQUEST, this._processRequest);
    }
}
/**
 * Creates a new RequestTransformer plugin.
 *
 * This function should be passed to `transport.addPlugin()` directly.
 *
 * @param _t - The Transport instance.
 * @param options - The options for the plugin.
 * @returns A RequestTransformer plugin instance.
 */
export function requestTransformerCreator(_t, options) {
    return new RequestTransformer(options);
}
//# sourceMappingURL=index.js.map